export const BASE_API_URL = 'https://scaffold-dev.deliverain.io:5555';
export const MASTER_MAPPING_API_URL = 'trialbalance/master/mappings';
export const GET_DETAILS_API_URL = 'trialbalance/detail';
export const GET_REPORT_GROUP_API_URL = 'trialbalance/report/group';
export const GET_REPORT_FS_NOTES_API_URL = 'trialbalance/report/fsNote';
export const GET_REPORT_FS_LINES_API_URL = 'trialbalance/report/fsLines';
export const GET_REPORT_AGGREGATE_API_URL = 'trialbalance/report/aggregate';
export const GET_REPORT_TESTING_SHEET_API_URL = 'trialbalance/report/testingSheet';
export const GET_REPORT_CAP_API_URL = 'trialbalance/report/capAggregate';
export const GET_REPORT_PAP_API_URL = 'trialbalance/report/apSection';
